// extracted by mini-css-extract-plugin
module.exports = {"container":"StepHeader_container__C-yi1","title":"StepHeader_title__NHDDZ","subtitle":"StepHeader_subtitle__2phVi","dark":"StepHeader_dark__1BaEc"};